var _defs, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaLibraryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#707070;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "media-library-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1113.25,203.19c-.63-10.15-3.36-19.8-7.12-29.15q-16.38-40.72-55.47-60.85c-17.57-9-36.4-12.68-56.06-12.68q-343.24,0-686.48,0c-2.1,0-4.2,0-6.3.06-12.19.6-24.16,2.45-35.71,6.55a114.53,114.53,0,0,0-56.84,43.06c-13.07,18.65-20.33,39.43-20.75,62.25-.15,7.65-.2,15.3-.2,23H172.16a86.53,86.53,0,0,0-86.53,86.53v692.24a86.53,86.53,0,0,0,86.53,86.53H864.4a86.54,86.54,0,0,0,85.53-73.45h53.63c4.11-.66,8.22-1.35,12.34-2,26.61-4.06,49-16.08,67.38-35.66a114,114,0,0,0,28.57-55.16c.66-3.05.82-6.22,1.33-9.31a39.21,39.21,0,0,1,1.19-4.2V206.51A13.27,13.27,0,0,1,1113.25,203.19ZM143.31,939.61V321.93a28.85,28.85,0,0,1,28.85-28.84H864.4a28.85,28.85,0,0,1,28.84,28.84V792.51L766.91,681.75a52.5,52.5,0,0,0-70.67,0L507,847.6a52.47,52.47,0,0,1-70.67,0l-58.69-51.48a52.5,52.5,0,0,0-70.67,0Zm914.57-30.73a70,70,0,0,1-.84,10.73c-3.13,19.92-13.87,34.49-31.5,44-9.74,5.27-20.35,6.85-31.32,6.85H950.93V321.93A86.55,86.55,0,0,0,864.4,235.4H244.68q0-8.94,0-17.87a63.63,63.63,0,0,1,.82-9.84c3.32-20.43,14.49-35.18,32.8-44.55,9.29-4.76,19.33-6.2,29.67-6.2H994.48c1.36,0,2.71,0,4.06,0,8.47.38,16.76,1.74,24.4,5.54,23,11.44,34.91,30.15,34.92,55.83Q1058,563.61,1057.88,908.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M824,435a77.45,77.45,0,1,1-77.45-77.44A77.44,77.44,0,0,1,824,435Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 1200,
    height: 1200
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaLibraryIcon);
export default __webpack_public_path__ + "static/media/media-library-icon.2db4f3c75fcfde647f1efd925f81d62a.svg";
export { ForwardRef as ReactComponent };